import axios from "axios";
import { Message } from "element-ui";
import store from "@/store";
import { getToken } from "@/utils/auth";
// import { getRoleToken } from "@/utils/auth";
import router from "@/router";

const whiteList = [`Authenticate`];
const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API
    ? process.env.VUE_APP_BASE_API
    : process.env.VUE_APP_PUBLIC_PATH,
});

service.interceptors.request.use(
  (config) => {
    if (store.getters.token) {
      config.headers["Authorization"] = `Bearer ${getToken()}`;
      // config.headers["X-Authorization"] = getRoleToken(); // <<<--- test Token
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

service.interceptors.response.use(
  (response) => {
    if (response.status === 201) {
      const reportMessage =
        response.data && response.data.token
          ? ` Отчет будет доступен по id ${response.data.token}`
          : ``;

      Message({
        message: `Данные обрабатываются.${reportMessage}`,
        type: `info`,
        duration: 8e3,
      });
    }
    return response.data;
  },
  (error) => {
    const {
      response: {
        status,
        data,
        data: { detail = `` },
      },
      config: { url },
    } = error;
    const reqAuth = whiteList.some((elem) => url.includes(elem));

    if (status === 401 && !reqAuth) {
      store.dispatch("user/resetToken").then(() => {
        const { currentRoute } = router;

        if (currentRoute.name !== `login`) {
          router.push({
            name: `login`,
            query: { redirect: currentRoute.path },
          });
        }

        Message({
          message: `Вы вышли из системы, войдите снова.`,
          type: "warning",
          duration: 5e3,
        });
      });
      return Promise.reject(error);
    }

    if (status === 422) {
      Message({
        message: `Ошибка валидации, проверьте данные.`,
        type: "warning",
        duration: 5e3,
      });
      return Promise.reject(data);
    }

    if (status === 412) {
      return Promise.reject(data);
    }

    Message({
      message: detail
        ? `${
            typeof detail === "object" ? JSON.stringify(detail) : detail
          } (${status})`
        : error.message,
      type: "error",
      duration: 5e3,
    });
    return Promise.reject(error);
  }
);

export default service;
